module.exports = __webpack_public_path__ + "img/l.e640e79a.jpg";